import createIcon from '../../createIcon';

/**
 * @component @name RecentActors
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNVYxOUgyM1Y1SDIxWk0xNyAxOUgxOVY1SDE3VjE5Wk0xNCA1SDJDMS40NSA1IDEgNS40NSAxIDZWMThDMSAxOC41NSAxLjQ1IDE5IDIgMTlIMTRDMTQuNTUgMTkgMTUgMTguNTUgMTUgMThWNkMxNSA1LjQ1IDE0LjU1IDUgMTQgNVpNOCA3Ljc1QzkuMjQgNy43NSAxMC4yNSA4Ljc2IDEwLjI1IDEwQzEwLjI1IDExLjI0IDkuMjQgMTIuMjUgOCAxMi4yNUM2Ljc2IDEyLjI1IDUuNzUgMTEuMjQgNS43NSAxMEM1Ljc1IDguNzYgNi43NiA3Ljc1IDggNy43NVpNMTIuNSAxN0gzLjVWMTYuMjVDMy41IDE0Ljc1IDYuNSAxNCA4IDE0QzkuNSAxNCAxMi41IDE0Ljc1IDEyLjUgMTYuMjVWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RecentActors = createIcon('RecentActors', [
  [
    'path',
    {
      d: 'M21 5V19H23V5H21ZM17 19H19V5H17V19ZM14 5H2C1.45 5 1 5.45 1 6V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V6C15 5.45 14.55 5 14 5ZM8 7.75C9.24 7.75 10.25 8.76 10.25 10C10.25 11.24 9.24 12.25 8 12.25C6.76 12.25 5.75 11.24 5.75 10C5.75 8.76 6.76 7.75 8 7.75ZM12.5 17H3.5V16.25C3.5 14.75 6.5 14 8 14C9.5 14 12.5 14.75 12.5 16.25V17Z',
      key: '119tid',
    },
  ],
]);

export default RecentActors;
